const PASSWORD = 'U2hhcmUgWW91ciBXZWRkaW5nIEZsb3dlcnM='; //64 encrypt of "Share Your Wedding Flowers"

// Convert text to ArrayBuffer
function str2ab(str) {
  const encoder = new TextEncoder();
  return encoder.encode(str);
}

// Convert ArrayBuffer to text
function ab2str(buffer) {
  const decoder = new TextDecoder();
  return decoder.decode(buffer);
}

// Web Crypto API Encode
async function webCryptoEncode(data) {
  const encodedData = str2ab(data);
  const pwHash = await crypto.subtle.digest('SHA-256', str2ab(PASSWORD));
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const key = await crypto.subtle.importKey('raw', pwHash, { name: 'AES-CBC', iv: iv }, false, [
    'encrypt',
  ]);
  const encryptedData = await crypto.subtle.encrypt({ name: 'AES-CBC', iv: iv }, key, encodedData);
  const ivStr = Array.from(iv)
    .map(b => String.fromCharCode(b))
    .join('');
  const encryptedStr = Array.from(new Uint8Array(encryptedData))
    .map(b => String.fromCharCode(b))
    .join('');
  return btoa(ivStr + encryptedStr);
}

// Web Crypto API Decode
async function webCryptoDecode(encryptedData) {
  const encryptedBytes = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0));
  const iv = encryptedBytes.slice(0, 16);
  const data = encryptedBytes.slice(16);
  const pwHash = await crypto.subtle.digest('SHA-256', str2ab(PASSWORD));
  const key = await crypto.subtle.importKey('raw', pwHash, { name: 'AES-CBC', iv: iv }, false, [
    'decrypt',
  ]);
  const decryptedData = await crypto.subtle.decrypt({ name: 'AES-CBC', iv: iv }, key, data);
  return ab2str(decryptedData);
}

// Fallback Encode
function fallbackEncode(data) {
  const strData = typeof data === 'object' ? JSON.stringify(data) : String(data);
  return btoa(strData.split('').reverse().join(''));
}

// Fallback Decode
function fallbackDecode(data) {
  const strData = atob(data).split('').reverse().join('');
  try {
    return JSON.parse(strData);
  } catch {
    return strData;
  }
}

// Encode Data with Fallback
export async function encodeData(data) {
  if (window.crypto && window.crypto.subtle) {
    return webCryptoEncode(data);
  } else {
    console.warn('Web Crypto API not available. Using fallback encoding.');
    return fallbackEncode(data);
  }
}

// Decode Data with Fallback
export async function decodeData(encryptedData) {
  if (window.crypto && window.crypto.subtle) {
    return webCryptoDecode(encryptedData);
  } else {
    console.warn('Web Crypto API not available. Using fallback decoding.');
    return fallbackDecode(encryptedData);
  }
}
